/**
 * Pont vers Sentry pour le code qui tourne avant ou sans lui : Sentry est chargé à la
 * demande (main.tsx), et ne l'est pas du tout sans VITE_SENTRY_DSN. Sans DSN, rien
 * n'est chargé ni appelé.
 */

const sentryConfigure = (): boolean => Boolean(import.meta.env.VITE_SENTRY_DSN);

export function signalerErreurReact(error: Error, componentStack?: string | null): void {
    if (!sentryConfigure()) return;
    void import('@sentry/react')
        .then((Sentry) => Sentry.captureException(error, { contexts: { react: { componentStack: componentStack ?? '' } } }))
        .catch(() => {});
}

/** Identifiant seulement : jamais courriel ni nom. `null` à la déconnexion. */
export function identifierArtisanSentry(id: string | null): void {
    if (!sentryConfigure()) return;
    void import('@sentry/react')
        .then((Sentry) => Sentry.setUser(id ? { id } : null))
        .catch(() => {});
}
